export default __webpack_public_path__ + "static/media/img-0798-greece-full-face.28ff62ea.png";